import AttractScreen from "./screens/AttractScreen";
import ExhibitHomeScreen from "./screens/ExhibitHomeScreen";
import WhatIsAIScreen from "./screens/WhatIsAIScreen";
import AIOrNotAIScreen from "./screens/AIOrNotAIScreen";
import AIFamilyScreen from "./screens/AIFamilyScreen";
import AIMythsScreen from "./screens/AIMythsScreen";
import HistoryScreen from "./screens/HistoryScreen";
import HistoryDriversScreen from "./screens/HistoryDriversScreen";
import HowAIWorksScreen from "./screens/HowAIWorksScreen";
import TrainMachineScreen from "./screens/TrainMachineScreen";
import SentimentClassificationScreen from "./screens/SentimentClassificationScreen";
import NeuralNetworkScreen from "./screens/NeuralNetworkScreen";
import NextTokenScreen from "./screens/NextTokenScreen";
import LLMToAssistantScreen from "./screens/LLMToAssistantScreen";
import AIMistakesScreen from "./screens/AIMistakesScreen";
import AITodayScreen from "./screens/AITodayScreen";
import JaggedFrontierScreen from "./screens/JaggedFrontierScreen";
import HumansPlusAIScreen from "./screens/HumansPlusAIScreen";
import ImpactScreen from "./screens/ImpactScreen";
import PeopleSocietyScreen from "./screens/PeopleSocietyScreen";
import PlanetScreen from "./screens/PlanetScreen";
import SourcesScreen from "./screens/SourcesScreen";
import AskAIAboutAIScreen from "./screens/AskAIAboutAIScreen";

export const AI_EXHIBIT_SCREEN_REGISTRY = Object.freeze({
  attract: Object.freeze({ id: "attract", component: AttractScreen }),
  home: Object.freeze({ id: "home", component: ExhibitHomeScreen }),
  what_is_ai: Object.freeze({ id: "what_is_ai", component: WhatIsAIScreen }),
  ai_or_not_ai: Object.freeze({ id: "ai_or_not_ai", component: AIOrNotAIScreen }),
  ai_family: Object.freeze({ id: "ai_family", component: AIFamilyScreen }),
  ai_myths: Object.freeze({ id: "ai_myths", component: AIMythsScreen }),
  history: Object.freeze({ id: "history", component: HistoryScreen }),
  history_drivers: Object.freeze({ id: "history_drivers", component: HistoryDriversScreen }),
  how_it_works: Object.freeze({ id: "how_it_works", component: HowAIWorksScreen }),
  train_machine: Object.freeze({ id: "train_machine", component: TrainMachineScreen }),
  sentiment: Object.freeze({ id: "sentiment", component: SentimentClassificationScreen }),
  neural_network: Object.freeze({ id: "neural_network", component: NeuralNetworkScreen }),
  next_token: Object.freeze({ id: "next_token", component: NextTokenScreen }),
  llm_assistant: Object.freeze({ id: "llm_assistant", component: LLMToAssistantScreen }),
  ai_mistakes: Object.freeze({ id: "ai_mistakes", component: AIMistakesScreen }),
  ai_today: Object.freeze({ id: "ai_today", component: AITodayScreen }),
  jagged_frontier: Object.freeze({ id: "jagged_frontier", component: JaggedFrontierScreen }),
  humans_ai: Object.freeze({ id: "humans_ai", component: HumansPlusAIScreen }),
  impact: Object.freeze({ id: "impact", component: ImpactScreen }),
  people_society: Object.freeze({ id: "people_society", component: PeopleSocietyScreen }),
  planet: Object.freeze({ id: "planet", component: PlanetScreen }),
  sources: Object.freeze({ id: "sources", component: SourcesScreen }),
  ask_ai: Object.freeze({ id: "ask_ai", component: AskAIAboutAIScreen }),
});

export function getAIExhibitScreen(screenId) {
  return AI_EXHIBIT_SCREEN_REGISTRY[screenId] || AI_EXHIBIT_SCREEN_REGISTRY.attract;
}
